import { Typography } from "@mui/material";
import React from "react";
import Can from "./Can";
import history from "utils/history";


const CanWrapper = (props) => {
    return <Can perform={props.perform}>
        {allowed => {
            if (!allowed) {
                history.replace("/");


                // Don't come here [Optional message in any case it's comes]
                return <div style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", height: "100%", width: "100%" }}>
                    <Typography align="center">{"Sorry, you don't have access to this section of the Hireweb, please contact an admin to be granted access"}</Typography>
                </div>;
            }
            return props.children;
        }}
    </Can>
}

export default CanWrapper;
